import { CHANNEL } from '@constants/channels';
import contactsHelper from './contacts';

const checkUniqueBulkContacts = (list, typeField) => {
    const uniqueMap = {};
    const uniqueList = [];
    for (const contact of list) {
        if (!uniqueMap[contact[typeField]]) {
            if (contact[typeField]) uniqueMap[contact[typeField]] = true;
            uniqueList.push(contact);
            continue;
        }
    }
    return uniqueList;
};

export const validateBulkData = (data, locale, channelType) => {
    if (!data || data.length === 0) return null;
    const list = [];
    const isEmail = channelType === CHANNEL.EMAIL;

    data.forEach(element => {
        if (isEmail) {
            contactsHelper.checkEmails(element, 'Email');
        } else {
            contactsHelper.checkPhoneNumbers(element, locale, 'Mobile_Number');
        }
        list.push(element);
    });
    const filteredEmptyValues = isEmail ? list.filter(item => item.Email) : list.filter(item => item.Mobile_Number);
    return checkUniqueBulkContacts(filteredEmptyValues, isEmail ? 'Email' : 'Mobile_Number');
};
